module.exports = __webpack_public_path__ + "static/media/System_Boundary-flooring_EDIT.d58661bf.png";